/**
 * i18n Performance Optimizer
 * Reduces network requests and improves loading performance
 */

// Preload critical translations using link tags
export const preloadCriticalTranslations = (language: string, namespaces: string[]) => {
  namespaces.forEach(ns => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'fetch';
    link.href = `/locales/${language}/${ns}.json`;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  });
};

// Batch load namespaces in parallel with concurrency control
export const batchLoadNamespaces = async (
  loadFunction: (namespaces: string[]) => Promise<any>,
  namespaces: string[],
  batchSize: number = 10
) => {
  const results = [];
  
  for (let i = 0; i < namespaces.length; i += batchSize) {
    const batch = namespaces.slice(i, i + batchSize);
    const result = await loadFunction(batch);
    results.push(result);
  }
  
  return results;
};

// Prefetch translations for likely next pages
export const prefetchTranslations = (language: string, namespaces: string[]) => {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => {
      namespaces.forEach(ns => {
        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = `/locales/${language}/${ns}.json`;
        link.crossOrigin = 'anonymous';
        document.head.appendChild(link);
      });
    });
  }
};

// Cache control headers optimizer
export const setupCacheHeaders = () => {
  // This would typically be done on the server side, but we can
  // use Service Worker to intercept and modify cache headers
  if ('serviceWorker' in navigator) {
    // Service worker would handle aggressive caching for i18n files
  }
};

// Performance monitoring for i18n loads
export const measureI18nPerformance = () => {
  const observer = new PerformanceObserver((list) => {
    const entries = list.getEntries();
    entries.forEach((entry) => {
      if (entry.name.includes('/locales/')) {
        // Silent monitoring - could send to analytics if needed
      }
    });
  });
  
  observer.observe({ entryTypes: ['resource'] });
  return observer;
};